import { COMING_SOON_IMAGE_BUCKET, type FeatureFlagKey } from "@klubora/shared";
import { supabase } from "./supabase";
import { resizeImage } from "./imageResize";

const MAX_WIDTH = 1080;
const MAX_BYTES = 5 * 1024 * 1024;

const EXT_BY_TYPE: Record<string, string> = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
};

function objectPath(tenantId: string, key: FeatureFlagKey, ext: string): string {
  return `${tenantId}/${key}.${ext}`;
}

export async function uploadComingSoonImage(
  tenantId: string,
  key: FeatureFlagKey,
  file: File,
): Promise<string> {
  const ext = EXT_BY_TYPE[file.type];
  if (!ext) throw new Error("Use JPEG, PNG ou WebP.");
  if (file.size > MAX_BYTES) throw new Error("A imagem deve ter no máximo 5 MB.");

  const blob = await resizeImage(file, MAX_WIDTH);
  const path = objectPath(tenantId, key, ext);

  const { error } = await supabase.storage.from(COMING_SOON_IMAGE_BUCKET).upload(path, blob, {
    contentType: file.type === "image/jpeg" ? "image/jpeg" : file.type,
    upsert: true,
  });
  if (error) throw new Error(`Falha no envio: ${error.message}`);

  const { data } = supabase.storage.from(COMING_SOON_IMAGE_BUCKET).getPublicUrl(path);
  return `${data.publicUrl}?v=${Date.now()}`;
}

export async function deleteComingSoonImage(tenantId: string, key: FeatureFlagKey): Promise<void> {
  const candidates = Object.values(EXT_BY_TYPE).map((ext) => objectPath(tenantId, key, ext));
  await supabase.storage.from(COMING_SOON_IMAGE_BUCKET).remove(candidates);
}
